import { render, staticRenderFns } from "./relic-detail-base.vue?vue&type=template&id=7d0de8db"
import script from "./relic-detail-base.vue?vue&type=script&lang=js"
export * from "./relic-detail-base.vue?vue&type=script&lang=js"
import style0 from "./relic-detail-base.vue?vue&type=style&index=0&id=7d0de8db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports